import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StickyContainer, Sticky } from 'react-sticky';
import { putRequest, getRequest } from '../../../requestUtils';
import LogisticsTab from '../LogisticsTab';
import CertificationsTab from '../CertificationsTab';
import ExpertiseTab from '../ExpertiseTab';
import ExperienceTab from '../ExperienceTab';
import ResponsibilitiesTab from '../ResponsibilitiesTab';
import SummaryTab from '../SummaryTab';
import TitleTabBar from '../TitleTabBar';
import './CreateProposal.scss';

class CreateProposal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: props.selectedTab || 0,
      activeTab: null,
      proposal: props.proposal,
      errors: {},
      unsaved_changes: false,
      resume: props.resume,
    };

    this.goBack = this.goBack.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.savePrevious = this.savePrevious.bind(this);
    this.saveContinue = this.saveContinue.bind(this);
    this.handleLeavePage = this.handleLeavePage.bind(this);
    this.handleViewUpdate = this.handleViewUpdate.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { selectedTab } = this.state;
    const { validateOnLoad } = this.props;
    // If we're here from the Review page, we want to validate the
    // entire proposal and display all errors for all tabs
    if (validateOnLoad) {
      this.saveProposal();
      this.setState({ activeTab: 3 });
    } else {
      this.setFormStep(selectedTab);
    }
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleLeavePage);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  setFormStep(index) {
    const { tabs } = this.props;
    const { proposal } = this.state;

    if (index < tabs.length) {
      proposal.form_step = tabs[index];
      this.setState({ proposal });
    }
  }

  goBack() {
    const { selectedTab, activeTab } = this.state;
    const index = selectedTab - 1;
    window.scrollTo(0, 0);
    if (activeTab <= selectedTab) {
      this.setState({ activeTab: selectedTab });
    }
    this.handleViewUpdate(index);
  }

  goForward() {
    const { selectedTab, activeTab } = this.state;
    const index = selectedTab + 1;
    window.scrollTo(0, 0);
    if (activeTab == null || activeTab <= selectedTab) {
      this.setState({ activeTab: selectedTab });
      this.setFormStep(index);
    }
    this.setState({ selectedTab: index });
  }

  toggleTab(e, index) {
    const { activeTab } = this.state;
    e.preventDefault();
    window.scrollTo(0, 0);
    if (activeTab === null || index > activeTab) {
      this.setFormStep(index);
    }
    this.handleViewUpdate(index);
  }

  handleFormChange(key, value) {
    const { proposal } = this.state;

    proposal[key] = value;

    this.setState({ proposal, unsaved_changes: true });
  }

  handleViewUpdate(index) {
    const { viewResumeUrl } = this.props;

    if (index === 0) {
      getRequest(viewResumeUrl, {})
        .then(({ data }) => { this.setState({ selectedTab: index, resume: data }); })
        .catch(() => { this.setState({ selectedTab: index, resume: null }); });
    } else {
      this.setState({ selectedTab: index });
    }
  }

  saveProposal(url = null) {
    const { csrfToken, proposalUrl } = this.props;

    return putRequest(
      proposalUrl,
      this.state.proposal,
      csrfToken,
    ).then(({ data }) => {
      if (url) {
        this.setState({ unsaved_changes: false });
        window.location.href = url;
      } else {
        this.setState({
          resume: data.resume,
          proposal: data.response,
          errors: data.errors,
          unsaved_changes: false,
        });
      }
    }).catch((err) => {
      this.setState({ errors: err });
    });
  }

  savePrevious() {
    this.saveProposal().then(() => {
      this.goBack();
    });
  }

  saveContinue() {
    this.saveProposal().then(() => {
      this.goForward();
    });
  }

  handleLeavePage(e) {
    if (this.state.unsaved_changes === true) {
      const confirmationMessage = 'You have some unsaved changes. Are you sure you want to leave?';
      e.returnValue = confirmationMessage;
      return confirmationMessage;
    }
    return null;
  }

  render() {
    const {
      selectedTab, activeTab, proposal, errors, resume,
    } = this.state;
    const {
      project,
      tabs,
      tabTitles,
      nonCompeteUrl,
      viewResumeUrl,
      uploadResumeUrl,
      csrfToken,
      redirectUrl,
      invitedToProject,
      userId,
      bio,
      screeningAnswers,
      showBackgroundCheck,
    } = this.props;

    return (
      <div className="proposal-container">
        <div className="save-and-continue-later-container">
          <a
            role="button"
            tabIndex={0}
            key="save"
            type="button"
            id="save-and-continue-later"
            className="body-text-3 medium"
            onClick={() => this.saveProposal(redirectUrl)}
          >
            SAVE & CONTINUE LATER
          </a>
        </div>
        <div className="card p-5 border-0">
          <StickyContainer>
            <Sticky>
              {
                ({ style }) => (
                  <TitleTabBar
                    style={style}
                    title="Proposal Draft"
                    tabs={tabs}
                    tabTitles={tabTitles}
                    toggleTab={this.toggleTab}
                    selectedTab={selectedTab}
                    activeTab={activeTab}
                    errors={errors}
                  />
                )
}
            </Sticky>

            <div className="tab-container">
              { (() => {
                switch (tabs[selectedTab]) {
                  case 'Summary':
                    return (
                      <SummaryTab
                        bio={bio}
                        project={project}
                        proposal={proposal}
                        onFormChange={this.handleFormChange}
                        errors={errors}
                        showResumeQuestion={!invitedToProject}
                        resume={resume}
                        deleteResume={this.deleteResume}
                        viewResumeUrl={viewResumeUrl}
                        uploadResumeUrl={uploadResumeUrl}
                        csrfToken={csrfToken}
                        userId={userId}
                      />
                    );
                  case 'Responsibilities':
                    return (
                      <ResponsibilitiesTab
                        project={project}
                        proposal={proposal}
                        onFormChange={this.handleFormChange}
                        errors={errors}
                      />
                    );
                  case 'Expertise':
                    return (
                      <ExpertiseTab
                        project={project}
                        proposal={proposal}
                        onFormChange={this.handleFormChange}
                        errors={errors}
                        csrfToken={csrfToken}
                        screeningAnswers={screeningAnswers}
                      />
                    );
                  case 'Experience':
                    return (
                      <ExperienceTab
                        project={project}
                        userId={userId}
                        proposal={proposal}
                        onFormChange={this.handleFormChange}
                        showResumeQuestion={!invitedToProject}
                        resume={resume}
                        deleteResume={this.deleteResume}
                        viewResumeUrl={viewResumeUrl}
                        errors={errors}
                        uploadResumeUrl={uploadResumeUrl}
                        csrfToken={csrfToken}
                      />
                    );
                  case 'Certifications':
                  case 'Education':
                    return (
                      <CertificationsTab
                        project={project}
                        proposal={proposal}
                        onFormChange={this.handleFormChange}
                        errors={errors}
                      />
                    );
                  case 'Logistics':
                    return (
                      <LogisticsTab
                        project={project}
                        proposal={proposal}
                        onFormChange={this.handleFormChange}
                        errors={errors}
                        nonCompeteUrl={nonCompeteUrl}
                        showBackgroundCheck={showBackgroundCheck}
                      />
                    );
                  default:
                    return null;
                }
              })() }

              <div className="actions">
                { selectedTab > 0
                  && (
                  <button
                    type="button"
                    id={`create-proposal-back-tab-${selectedTab}`}
                    className="btn btn-secondary back-btn"
                    onClick={this.savePrevious}
                  >
                    <i className="fa fa-chevron-left mr-5" />
                    { tabs[selectedTab - 1] }
                  </button>
                  )}

                { selectedTab < tabs.length - 1
                  ? (
                    <button
                      key="submit"
                      type="button"
                      id={`create-proposal-continue-tab-${selectedTab}`}
                      className="btn btn-primary next-btn right-side"
                      onClick={this.saveContinue}
                    >
                      { tabs[selectedTab + 1] }
                      <i className="fa fa-chevron-right ms-2" />
                    </button>
                  )
                  : (
                    <button
                      key="save"
                      type="button"
                      id={`create-proposal-review-tab-${selectedTab}`}
                      className="btn btn-primary next-btn right-side"
                      onClick={() => this.saveProposal(redirectUrl)}
                    >
                      Review & Submit
                    </button>
                  )}
              </div>
            </div>
          </StickyContainer>
        </div>
      </div>
    );
  }
}

CreateProposal.propTypes = {
  proposal: PropTypes.shape({}).isRequired,
  bio: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  project: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  proposalUrl: PropTypes.string.isRequired,
  uploadResumeUrl: PropTypes.string.isRequired,
  resume: PropTypes.shape({}),
  viewResumeUrl: PropTypes.string.isRequired,
  nonCompeteUrl: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabTitles: PropTypes.arrayOf(PropTypes.string),
  redirectUrl: PropTypes.string.isRequired,
  validateOnLoad: PropTypes.bool,
  invitedToProject: PropTypes.bool,
  screeningAnswers: PropTypes.arrayOf(PropTypes.shape({})),
  selectedTab: PropTypes.number,
  showBackgroundCheck: PropTypes.bool,
};

CreateProposal.defaultProps = {
  resume: null,
  nonCompeteUrl: null,
  tabs: ['Responsibilities', 'Experience', 'Certifications', 'Logistics'],
  tabTitles: ['Responsibilities', 'Experience', 'Certifications', 'Logistics'],
  validateOnLoad: false,
  invitedToProject: false,
  screeningAnswers: [],
  selectedTab: null,
  showBackgroundCheck: false,
};

export default CreateProposal;
